enum Terms {
  NET0 = 'NET 0',
}

export default Terms;
